<template>
  <div class="flex md12 adresse-infos">
    <div class="row">
      <div class="flex md12">
        <va-input
          :disabled="isDisabled"
          v-model="adresseInfosMod.adresse"
          placeholder="Adresse inconnue"
          label="Adresse"
        />
      </div>
      <div class="flex md12">
        <va-input
          :disabled="isDisabled"
          v-model="adresseInfosMod.complement"
          placeholder="Complement d'adresse"
          label="Adresse suite"
        />
      </div>
      <div class="flex md2">
        <va-input
          :disabled="isDisabled"
          v-model="adresseInfosMod.code_postal"
          placeholder="Code Postal"
          label="Code Postal"
        />
      </div>
      <div class="flex md7">
        <va-input
          :disabled="isDisabled"
          v-model="adresseInfosMod.ville"
          placeholder="Ville"
          label="Ville"
        />
      </div>
      <div class="flex md3">
        <va-input
          :disabled="isDisabled"
          v-model="adresseInfosMod.cedex"
          placeholder="Cedex"
          label="Cedex"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep, isEqual } from "lodash";

export default {
  props: ["adresseInfos", "isDisabled"],

  data() {
    return {
      infosUpdated: false,
      adresseInfosMod: {
        id: null,
        code_postal: null,
        ville: null,
        adresse: null,
        complement: null,
        cedex: null
      }
    };
  },
  mounted() {},
  methods: {},
  computed: {
    isFormValid: function() {
      if (this.validSurname || this.validName) {
        return false;
      }
      return true;
    },
    validName: function() {
      return false;
    },
    validSurname: function() {
      return false;
    }
  },
  watch: {
    adresseInfosMod: {
      deep: true,
      handler() {
        if (!isEqual(this.adresseInfosMod, this.adresseInfos)) {
          this.$emit("infosChanged", true);
          this.infosUpdated = true;
        } else {
          this.$emit("infosChanged", false);
          this.infosUpdated = false;
        }
      }
    },
    adresseInfos: {
      deep: true,
      immediate: true,
      handler() {
        this.adresseInfosMod = cloneDeep(this.adresseInfos);
      }
    }
  }
};
</script>

<style lang="scss">
.adresse-infos > * > .flex {
  padding-left: 0.25rem;
}
</style>
